import { login } from "@/maintain/api/login/user";
import TokenStore from "@/utils/tokenStore";
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
  },
  state: {
    token: TokenStore.getToken("maintain"),
  },
  getters,
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            commit("SET_TOKEN", res.access_token);
            TokenStore.setToken("maintain", res.access_token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});

export default store;
